import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldCheckbox from '../../components/FieldCheckbox';
import FieldSelect from '../../components/FieldSelect';
import Button from '../../components/Button';
import ButtonShowModal from '../../components/ButtonShowModal';
import ErrorValidation from '../../components/ErrorValidation';
import cardVisa from '../../assets/card-visa.svg';
import cardMaster from '../../assets/card-mastercard.svg';
import info from '../../assets/icon-info.svg';
import styles from './styles.module.scss';

const Explanations = () => (
  <ButtonShowModal
    label={(
      <div className={styles.explanationLabel}>
        <img src={info} alt="info"/>
        <FormattedMessage
          id='common.form.input.info'
          defaultMessage='Info'
        />
      </div>
    )}
    headerContent={(
      <FormattedMessage
        id={'step4.modal.header'}
        defaultMessage={'Explanations regarding the branch number'}
      />
    )}
  >
    {() => (
      <>
        <h2 className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.subheader.1'}
          />
        </h2>
        <div className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.text.1'}
            defaultMessage={'The branch appears in the credit card below under the credit number, where you have the account number with such a slash, on its part there is the branch number, 3 digits'}
          />
        </div>
        <img src={cardVisa} alt="visa" className={styles.cardImg}/>
        <h2 className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.subheader.2'}
          />
        </h2>
        <div className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.text.2'}
            defaultMessage={'Alternatively, on the card is a series of relatively small digits that look like this: 11 222 333333'}
          />
          <br/>
          <FormattedMessage
            id={'step4.modal.text.6'}
            defaultMessage={'Alternatively, on the card is a series of relatively small digits that look like this: 11 222 333333'}
          />
        </div>
        <div className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.text.3'}
            defaultMessage={'So the long digits are the number of the account'}
          />
        </div>
        <div className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.text.4'}
            defaultMessage={'the shortest is the bank number'}
          />
        </div>
        <div className={styles.cardText}>
          <FormattedMessage
            id={'step4.modal.text.5'}
            defaultMessage={'and those in the middle are the branch number'}
          />
        </div>
        <img src={cardMaster} alt="mastercard" className={styles.cardImg}/>
      </>
    )}
  </ButtonShowModal>
);

const Step4View = ({
                     loadOptions: {
                       bank
                     },
                     values,
                     isValid,
                   }) => {
  const {formatMessage} = useIntl();
  const bankPlaceholder = formatMessage({
    id: 'step4.form.bank.placeholder',
    defaultMessage: 'Write bank number'
  });
  const branchPlaceholder = formatMessage({
    id: 'step4.form.branch.placeholder',
    defaultMessage: 'Write branch number'
  });
  const accountPlaceholder = formatMessage({
    id: 'step4.form.account.placeholder',
    defaultMessage: 'Please write account number'
  });

  return (
    <Form className={styles.formContainer}>
      <div className={styles.input}>
        <FieldSelect
          fieldId='bankName'
          loadOptions={bank}
          label={(
            <FormattedMessage
              id='step4.form.bank.label'
              defaultMessage='Bank Name'
            />
          )}
          placeholder={bankPlaceholder}
          disabled={values.checkOnly}
        />
      </div>
      <FieldInput
        fieldId='branchNum'
        label={(
          <FormattedMessage
            id='step4.form.branch.label'
            defaultMessage='Branch Number'
          />
        )}
        placeholder={branchPlaceholder}
        info={<Explanations/>}
        containerStyles={styles.input}
        disabled={values.checkOnly}
      />
      <FieldInput
        fieldId='accountNum'
        label={(
          <FormattedMessage
            id='step4.form.account.label'
            defaultMessage='Account Number'
          />
        )}
        placeholder={accountPlaceholder}
        containerStyles={styles.input}
        disabled={values.checkOnly}
      />
      <FieldCheckbox
        fieldId={'checkOnly'}
        label={(
          <FormattedMessage
            id='step4.form.isInterested.label'
            defaultMessage='I am interested in accepting the dough payment and not by bank transfer'
          />
        )}
        containerStyles={styles.input}
      />

      <Button
        type='submit'
        label={(
          <FormattedMessage
            id='common.form.button.save'
            defaultMessage='Start'
          />
        )}
      />
      {!isValid && <ErrorValidation/>}
    </Form>
  )
};

Step4View.propTypes = {
  loadOptions: PropTypes.shape({
    bank: PropTypes.func,
  }),
  values: PropTypes.object,
  isValid: PropTypes.bool,
};

export default Step4View;
